import logger from 'shared/services/logger'

import Storage from './storage'

class LastActivityService {
  storage = new Storage('sessionStorage')
  STORAGE_KEYS = {
    categories: 'LAST_ACTIVITY_CATEGORIES',
    products: 'LAST_ACTIVITY_PRODUCTS',
    topics: 'LAST_ACTIVITY_TOPICS',
  }
  MAX_SAVED_ITEMS = 3
  isEnabled = false

  constructor() {
    this.isEnabled = this.storage.isAvailable()
    if (!this.isEnabled) {
      logger.info('LastActivityService is not available')
    }
  }

  get = key => {
    if (!this.isEnabled) {
      return []
    }
    return this.storage.get(key) || []
  }

  getCategories = () => this.get(this.STORAGE_KEYS.categories)

  getProducts = () => this.get(this.STORAGE_KEYS.products)

  getTopics = () => this.get(this.STORAGE_KEYS.topics)

  add = (key, value) => {
    if (!this.isEnabled) {
      return
    }

    let lastActivityHistory = this.get(key) || []
    lastActivityHistory = lastActivityHistory.filter(
      item => item.id !== value.id
    )

    lastActivityHistory.unshift(value)
    if (lastActivityHistory.length > this.MAX_SAVED_ITEMS) {
      lastActivityHistory.pop()
    }

    try {
      this.storage.set(key, lastActivityHistory)
    } catch (e) {
      logger.error(e.message)
    }
  }

  addCategory = category => {
    this.add(this.STORAGE_KEYS.categories, category)
  }

  addProduct = product => {
    this.add(this.STORAGE_KEYS.products, product)
  }

  addTopic = topic => {
    this.add(this.STORAGE_KEYS.topics, topic)
  }

  clear = () => {
    if (this.isEnabled) {
      ;[...Object.keys(this.STORAGE_KEYS)].forEach(key => {
        this.storage.set(this.STORAGE_KEYS[key], [])
      })
    }
  }
}

export default new LastActivityService()
